<script>
	'use strict'

	import AppHeader from './components/AppHeader.svelte';
	import MapTilers from './components/MapTilers.svelte';
	import TileSelector from './components/TileSelector.svelte';
	import AutoSaveMap from './components/AutoSaveMap.svelte';
</script>


<AutoSaveMap></AutoSaveMap>

<div class="main-app">
	<div class="header">
		<AppHeader></AppHeader>
	</div>
	<div class="map-tiler">
		<MapTilers />
	</div>
	<div>
		<TileSelector></TileSelector>
	</div>
</div>

<style>
	:root {
		--tileX: 10;
    --tileY: 5;
		--grid-gap: 0;
		--tile-size: 64px;
		--grid-tile-size: 64px;
		--nb-tiles: 2;
		--padding-main-app: 12px;
		--background-color: #242424;
		--section-color: #202020;
		--section-color-alpha: #2020204d;
		--font-color: #ffc107;
		--hightlight-color: #ffc107;
		--grid-color: #242424;
		--border-radius: 0;
	}

	.header {
		background: var(--section-color);
		padding: 6px;
		display: flex;
    justify-content: space-between;
	}

	.map-tiler {
		background: var(--background-color);
		overflow: auto;
	}
</style>
